import { render, staticRenderFns } from "./CalendarLayout.vue?vue&type=template&id=0b322183&scoped=true"
import script from "./CalendarLayout.vue?vue&type=script&lang=js"
export * from "./CalendarLayout.vue?vue&type=script&lang=js"
import style0 from "./CalendarLayout.vue?vue&type=style&index=0&id=0b322183&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b322183",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b322183')) {
      api.createRecord('0b322183', component.options)
    } else {
      api.reload('0b322183', component.options)
    }
    module.hot.accept("./CalendarLayout.vue?vue&type=template&id=0b322183&scoped=true", function () {
      api.rerender('0b322183', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/CalendarLayout.vue"
export default component.exports